import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters('globalSearch', [
      'getFacets',
      'getHighlightedIndex',
      'getLoadingResultIndex',
      'isGlobalSearchFocused',
      'isLoadingResult',
    ]),
  },
  methods: {
    ...mapMutations('globalSearch', [
      'nextIndex',
      'prevIndex',
      'resetIndex',
      'resetFacets',
      'setIndex',
      'setLoadingResult',
    ]),
    ...mapActions('globalSearch', [
      'blurGlobalSearch',
      'focusGlobalSearch',
      'toggleFacet',
    ]),
  },
};
